import { Store } from "../store";

export default function useCheckout () {
  const checkout = Store.useState(s => s.checkout);

  const hasInBasket = listingId => checkout && !!checkout.items.find(i => i.listing.id === listingId);

  return { hasInBasket };
}
